import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import { useTranslation } from "react-i18next";

import video1 from "images/videosdj/findeanocondesa.mp4";
import video2 from "images/videosdj/afterpulse.mp4";
import video3 from "images/videosdj/sublaim.mp4";
import videoVertical from "images/videosdj/condesa2.mp4";
import videoVertical2 from "images/videosdj/sonicosublee1.MOV";
import videoVertical3 from "images/videosdj/superman.mp4";

const Container = tw.div`relative bg-black text-white`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ThreeColumn = tw.div`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap`;
const Column = tw.div`mt-24 lg:w-1/3`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-300 text-center max-w-sm`;

const Card = tw.div`lg:mx-4 xl:mx-8 max-w-sm lg:max-w-xs`;
const Video = styled.video`
  ${tw`bg-cover bg-center rounded`}
  width: 100%;
  height: ${(props) => (props.isVertical ? 'auto' : '20rem')};
  max-height: ${(props) => (props.isVertical ? '50vh' : 'none')};
`;
const Category = tw.div`mt-4 text-gray-300 font-bold text-sm`;
const Title = tw.h4`mt-2 leading-relaxed font-bold text-lg text-white`;
const Link = tw.a`inline-block mt-2 text-sm text-blue-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-blue-500`;

const GlowingHeading = styled(HeadingTitle)`
  color: #ffffff;
  text-shadow:
    0 0 4px rgba(255, 255, 255, 0.4),
    0 0 8px rgba(255, 255, 255, 0.3),
    0 0 12px rgba(255, 255, 255, 0.2);
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  animation: softGlow 2.5s ease-in-out infinite alternate;

  @keyframes softGlow {
    0% {
      text-shadow:
        0 0 3px rgba(255, 255, 255, 0.3),
        0 0 6px rgba(255, 255, 255, 0.2),
        0 0 9px rgba(255, 255, 255, 0.1);
    }
    100% {
      text-shadow:
        0 0 6px rgba(255, 255, 255, 0.6),
        0 0 12px rgba(255, 255, 255, 0.4),
        0 0 18px rgba(255, 255, 255, 0.2);
    }
  }
`;

export default () => {
  const { t } = useTranslation();

  const blogPosts = [
    {
      videoSrc: video1,
      category: t("videos.0.category"),
      title: t("videos.0.title"),
      url: "https://timerse.com"
    },
    {
      videoSrc: video2,
      category: t("videos.1.category"),
      title: t("videos.1.title")
    },
    {
      videoSrc: video3,
      category: t("videos.2.category"),
      title: t("videos.2.title"),
      url: "https://timerse.com"
    },
    {
      videoSrc: videoVertical,
      category: t("videos.3.category"),
      title: t("videos.3.title"),
      isVertical: true
    },
    {
      videoSrc: videoVertical2,
      category: t("videos.4.category"),
      title: t("videos.4.title"),
      isVertical: true
    },
    {
      videoSrc: videoVertical3,
      category: t("videos.5.category"),
      title: t("videos.5.title"),
      isVertical: true
    }
  ];

  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          <GlowingHeading>{t("videos.title")}</GlowingHeading>
          <HeadingDescription>{t("videos.description")}</HeadingDescription>
        </HeadingInfoContainer>

        <ThreeColumn>
          {blogPosts.map((post, index) => (
            <Column key={index}>
              <Card>
                <Video controls isVertical={post.isVertical}>
                  <source src={post.videoSrc} type="video/mp4" />
                  Your browser does not support the video tag.
                </Video>
                <Category>{post.category}</Category>
                <Title>{post.title}</Title>
                {post.url && <Link href={post.url}></Link>}
              </Card>
            </Column>
          ))}
        </ThreeColumn>
      </Content>
    </Container>
  );
};